import React from 'react';
import styled from '../../../libs/styled.es.js';
import { LazyImage } from '../LazyImage/LazyImage.es.js';

const ComboImageWrapper = styled.div((props) => ({
  width: props.width ? `${props.width}px` : "80px",
  height: props.height ? `${props.height}px` : "80px",
  background: "#F8F8FC",
  borderRadius: "4px",
  position: "relative",
  cursor: "pointer"
}));
const ChildImage = styled.img((props) => ({
  borderRadius: "4px",
  width: props.width ? `${props.width}px` : "34px",
  height: props.height ? `${props.height}px` : "34px",
  margin: "4px 0 0 4px",
  border: props.isContainBorder ? "solid 1px #E4E5F0" : "unset"
}));
const RemainingNumber = styled.div`
  position: absolute;
  width: 34px;
  height: 34px;
  border-radius: 4px;
  background: rgba(27, 29, 41, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  line-height: 16px;
  color: #ffffff;
  border: 4px;
  right: 4px;
  bottom: 4px;
`;
const IMAGE_LIMIT = 4;
const ComboImage = ({
  images,
  alt = [],
  keys = [],
  width,
  height,
  childHeight,
  childWidth,
  isContainBorder
}) => {
  const isSingleImage = images.length === 1;
  if (isSingleImage)
    return /* @__PURE__ */ React.createElement(LazyImage, {
      src: images.shift(),
      height: height || 80,
      width: width || 80,
      alt: "product",
      contain: true,
      border: true
    });
  const remainImage = images.length - IMAGE_LIMIT;
  return /* @__PURE__ */ React.createElement(ComboImageWrapper, {
    width,
    height
  }, images.slice(0, IMAGE_LIMIT).map((image, index) => /* @__PURE__ */ React.createElement(ChildImage, {
    width: childWidth,
    height: childHeight,
    isContainBorder,
    src: image,
    alt: alt[index],
    key: keys[index] || index
  })), remainImage > 0 && /* @__PURE__ */ React.createElement(RemainingNumber, null, "+", remainImage + 1));
};

export { ComboImage };
